import { Desktop } from '@99designs/common/components/Desktop';
import { Icon } from '@99designs/common/components/Icon';
import { Mobile } from '@99designs/common/components/Mobile';
import { breakpoints } from '@99designs/common/core/settings';
import spaces from '@99designs/common/core/settings/spaces';
import { typeScale } from '@99designs/common/core/settings/typography';
import { DesignerCard_User } from '__generated__/DesignerCard_User';
import React, { useContext, useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';
import BriefContext from './BriefContext';
import Card from './Card';
import DesignCarousel from './DesignCarousel';
import DesignerCardContext from './DesignerCardContext';
import DesignerMeta from './DesignerMeta';
import FileOverlay from './FileOverlay';

export interface Props {
    user: DesignerCard_User;
    isSelected: boolean;
    onMount: () => void;
    children: React.ReactNode;
    isTopMatch?: boolean;
}

const Label = styled.span`
    background: black;
    position: absolute;
    top: ${spaces.space6}px;
    left: 0;
    padding: ${spaces.space3}px ${spaces.space7}px;
    color: white;
    z-index: 1;
    font-size: ${typeScale.size2}px;
`;

export default function DesignerCard(props: Props) {
    const { user, isSelected, children, onMount, isTopMatch } = props;

    useEffect(() => {
        onMount();
    }, []);

    const [isOverlayActive, updateIsOverlayActive] = useState(false);
    const [showFullBiography, updateShowFullBiography] = useState(false);
    const [activeDesign, updateActiveDesign] = useState(0);
    const { themeName } = useContext(BriefContext);
    const { highlightNewDesigners, displayStatsTable } = useContext(DesignerCardContext);
    const theme = themeName ? themeName : '';

    const cardVariations = ['designer-card', theme];
    return (
        <Card variations={isSelected ? [...cardVariations, 'selected'] : cardVariations}>
            <Card.Media>
                {isTopMatch && (
                    <Label>
                        <Icon type="star-2" /> {__('Top match')}
                    </Label>
                )}

                <MediaQuery minWidth={breakpoints.normal[0]}>
                    {matches => (
                        <DesignCarousel
                            designer={user}
                            isClickable={matches}
                            showPaginators={false}
                            onClick={() => {
                                updateIsOverlayActive(true);
                            }}
                            onChange={designIndex => {
                                updateActiveDesign(designIndex);
                            }}
                            selectedIndex={activeDesign}
                        />
                    )}
                </MediaQuery>
                {isOverlayActive && (
                    <FileOverlay
                        designer={user}
                        selectedDesignIndex={activeDesign}
                        onClose={() => updateIsOverlayActive(false)}
                        onDesignChange={designIndex => {
                            updateActiveDesign(designIndex);
                        }}
                    />
                )}
            </Card.Media>
            <Card.Block>
                <Desktop>
                    <DesignerMeta
                        designer={user}
                        onClickDescription={() => {
                            updateIsOverlayActive(true);
                        }}
                        isCompact={true}
                        highlightNewDesigners={highlightNewDesigners}
                        displayStatsTable={displayStatsTable}
                    />
                </Desktop>
                <Mobile>
                    <DesignerMeta
                        designer={user}
                        onClickDescription={() => {
                            updateShowFullBiography(!showFullBiography);
                        }}
                        showFullBiography={showFullBiography}
                        highlightNewDesigners={highlightNewDesigners}
                        displayStatsTable={displayStatsTable}
                    />
                </Mobile>
            </Card.Block>
            <Card.Block>{children}</Card.Block>
        </Card>
    );
}
